module.exports = __webpack_public_path__ + "static/media/obxWhite.09d8c3e8.png";